import { render } from "./endereco-contato.vue?vue&type=template&id=4c6d5f76"
import script from "./endereco-contato.vue?vue&type=script&lang=js"
export * from "./endereco-contato.vue?vue&type=script&lang=js"

import "./endereco-contato.vue?vue&type=style&index=0&id=4c6d5f76&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__